import { useState, useEffect, useRef } from 'react';
import AuthShell from './AuthShell';
import { Button } from '../ui/button';

const VerifyEmailScreen = ({ api, onDone }) => {
  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [message, setMessage] = useState('');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; // StrictMode double-invoke guard
    ran.current = true;
    const token = new URLSearchParams(window.location.search).get('token');
    if (!token) {
      setStatus('error'); setMessage('This verification link is missing its token.');
      return;
    }
    api.post('/auth/verify', { token })
      .then((res) => { setStatus('success'); setMessage(res.message || 'Email verified.'); })
      .catch((err) => { setStatus('error'); setMessage(err.message || 'Verification failed.'); });
  }, [api]);

  return (
    <AuthShell title="Email verification">
      <div className="text-center space-y-4">
        {status === 'verifying' && <p className="text-sm text-muted-foreground">Verifying your email…</p>}
        {status === 'success' && <p className="text-sm text-foreground">{message}</p>}
        {status === 'error' && <p className="text-sm text-destructive">{message}</p>}
        {status !== 'verifying' && (
          <Button onClick={() => onDone('login')} className="w-full">Go to sign in</Button>
        )}
      </div>
    </AuthShell>
  );
};

export default VerifyEmailScreen;
